/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { CompaniesService } from './services/CompaniesService';
import { CompanyDetailsService } from './services/CompanyDetailsService';
import { CrmConnectionsService } from './services/CrmConnectionsService';
import { CrmConnectionsHubspotService } from './services/CrmConnectionsHubspotService';
import { DefaultService } from './services/DefaultService';
import { HealthService } from './services/HealthService';
import { HooksService } from './services/HooksService';
import { IconUtilsService } from './services/IconUtilsService';
import { IndustriesService } from './services/IndustriesService';
import { ListsService } from './services/ListsService';
import { ListsDynamicService } from './services/ListsDynamicService';
import { ListsEnrichmentService } from './services/ListsEnrichmentService';
import { ListsPredictiveService } from './services/ListsPredictiveService';
import { ListsStaticService } from './services/ListsStaticService';
import { LocationsService } from './services/LocationsService';
import { OfficeDetailsService } from './services/OfficeDetailsService';
import { OnboardingService } from './services/OnboardingService';
import { PaymentsService } from './services/PaymentsService';
import { PlansService } from './services/PlansService';
import { PredictiveCampaignPricesService } from './services/PredictiveCampaignPricesService';
import { PredictiveCampaignQuestionsService } from './services/PredictiveCampaignQuestionsService';
import { PredictiveCampaignsService } from './services/PredictiveCampaignsService';
import { PredictiveProductQuestionsService } from './services/PredictiveProductQuestionsService';
import { PredictiveProductsService } from './services/PredictiveProductsService';
import { SelectListsService } from './services/SelectListsService';
import { SelectOptionsService } from './services/SelectOptionsService';
import { SelectSearchService } from './services/SelectSearchService';
import { UsersService } from './services/UsersService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class BackendClient {
    public readonly companies: CompaniesService;
    public readonly companyDetails: CompanyDetailsService;
    public readonly crmConnections: CrmConnectionsService;
    public readonly crmConnectionsHubspot: CrmConnectionsHubspotService;
    public readonly default: DefaultService;
    public readonly health: HealthService;
    public readonly hooks: HooksService;
    public readonly iconUtils: IconUtilsService;
    public readonly industries: IndustriesService;
    public readonly lists: ListsService;
    public readonly listsDynamic: ListsDynamicService;
    public readonly listsEnrichment: ListsEnrichmentService;
    public readonly listsPredictive: ListsPredictiveService;
    public readonly listsStatic: ListsStaticService;
    public readonly locations: LocationsService;
    public readonly officeDetails: OfficeDetailsService;
    public readonly onboarding: OnboardingService;
    public readonly payments: PaymentsService;
    public readonly plans: PlansService;
    public readonly predictiveCampaignPrices: PredictiveCampaignPricesService;
    public readonly predictiveCampaignQuestions: PredictiveCampaignQuestionsService;
    public readonly predictiveCampaigns: PredictiveCampaignsService;
    public readonly predictiveProductQuestions: PredictiveProductQuestionsService;
    public readonly predictiveProducts: PredictiveProductsService;
    public readonly selectLists: SelectListsService;
    public readonly selectOptions: SelectOptionsService;
    public readonly selectSearch: SelectSearchService;
    public readonly users: UsersService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.companies = new CompaniesService(this.request);
        this.companyDetails = new CompanyDetailsService(this.request);
        this.crmConnections = new CrmConnectionsService(this.request);
        this.crmConnectionsHubspot = new CrmConnectionsHubspotService(this.request);
        this.default = new DefaultService(this.request);
        this.health = new HealthService(this.request);
        this.hooks = new HooksService(this.request);
        this.iconUtils = new IconUtilsService(this.request);
        this.industries = new IndustriesService(this.request);
        this.lists = new ListsService(this.request);
        this.listsDynamic = new ListsDynamicService(this.request);
        this.listsEnrichment = new ListsEnrichmentService(this.request);
        this.listsPredictive = new ListsPredictiveService(this.request);
        this.listsStatic = new ListsStaticService(this.request);
        this.locations = new LocationsService(this.request);
        this.officeDetails = new OfficeDetailsService(this.request);
        this.onboarding = new OnboardingService(this.request);
        this.payments = new PaymentsService(this.request);
        this.plans = new PlansService(this.request);
        this.predictiveCampaignPrices = new PredictiveCampaignPricesService(this.request);
        this.predictiveCampaignQuestions = new PredictiveCampaignQuestionsService(this.request);
        this.predictiveCampaigns = new PredictiveCampaignsService(this.request);
        this.predictiveProductQuestions = new PredictiveProductQuestionsService(this.request);
        this.predictiveProducts = new PredictiveProductsService(this.request);
        this.selectLists = new SelectListsService(this.request);
        this.selectOptions = new SelectOptionsService(this.request);
        this.selectSearch = new SelectSearchService(this.request);
        this.users = new UsersService(this.request);
    }
}

